import {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import {HexColorPicker} from "react-colorful";
import styles from "./color-picker.module.css"
import Button from "../button/button.jsx";
import {
    useFloating,
    offset,
    flip,
    shift,
    autoUpdate
} from "@floating-ui/react";


const ColorPicker = ({color, setColor, presetColors = [], size = {height: 16, width: 16}, label, labelClassName}) => {
    const [currentColor, setCurrentColor] = useState(color)
    const [showPicker, setShowPicker] = useState(false);

    const {
        refs,
        floatingStyles,
        update
    } = useFloating({
        placement: "right-start",
        middleware: [
            offset(5),
            flip({
                fallbackPlacements: [
                    "top-center",
                    "right-end",
                    "left-start",
                    "top-start",
                    "top-end",
                    "bottom-start",
                    "bottom-end"
                ]
            }),
            shift({ padding: 10 })
        ],
        whileElementsMounted: autoUpdate
    });

    const cancel = () => {
        setCurrentColor(color);
        setShowPicker(false);
    }

    const apply = () => {
        setColor(currentColor)
        setShowPicker(false);
    }

    const handleToggle = () => {
        setShowPicker(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            if(showPicker) setShowPicker(false);
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [showPicker]);

    useEffect(() => {
        if (!showPicker) return;

        const onClick = e => {
            if (
                !refs.reference.current?.contains(e.target) &&
                !refs.floating.current?.contains(e.target)
            ) {
                setShowPicker(false);
            }
        };

        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, [showPicker]);

    return (
        <div className="flex gap-2 cursor-pointer w-fit items-center">
            <span className={labelClassName}
                  onClick={handleToggle}
            >{label}</span>
            <div
                ref={refs.setReference}
                style={{ ...size, background: currentColor || "#000" }}
                onClick={() => setShowPicker(prev => !prev)}
            />
            {showPicker && createPortal(
                <div
                    ref={refs.setFloating}
                    style={{
                        ...floatingStyles,
                        width: 190,
                    }}
                    className={`z-[9999] border border-black/12 p-2 shadow rounded bg-white ${styles.customLayoutReactColorful}`}
                >
                    <HexColorPicker color={currentColor} onChange={setCurrentColor} />

                    <div className="flex gap-1 mt-1.5 justify-end flex-wrap">
                        {presetColors.map(presetColor => (
                            <button
                                key={presetColor}
                                className="w-[18px] h-[18px] rounded"
                                style={{ background: presetColor }}
                                onClick={() => setCurrentColor(presetColor)}
                            />
                        ))}
                    </div>

                    <div className="flex gap-1 mt-1.5 justify-end">
                        <Button className="text-[11px] px-2! h-[24px]!" target="secondary" onClick={cancel}>Cancelar</Button>
                        <Button className="text-[11px] px-2! h-[24px]!" onClick={apply}>Salvar</Button>
                    </div>
                </div>,
                document.body
            )}
        </div>
    )
}

export default ColorPicker;